import type { CourseListParams } from '../types/course.types'

export const coursesKeys = {
  all: ['courses'] as const,
  lists: () => [...coursesKeys.all, 'list'] as const,
  list: (params: CourseListParams) => [...coursesKeys.lists(), params] as const,
  details: () => [...coursesKeys.all, 'detail'] as const,
  detail: (slug: string) => [...coursesKeys.details(), slug] as const,
}
